import React, { Component } from "react";
import Lightbox from "react-lightbox-gallery";
import PageFooter from "../../components/PageFooter";
import pattern from "../../assets/pattern.jpg";

import galleryImg3 from "../../assets/gallery/wedding/wedding03.jpg";
import galleryImg4 from "../../assets/gallery/wedding/wedding04.jpg";
import galleryImg5 from "../../assets/gallery/wedding/wedding05.jpg";
import galleryImg6 from "../../assets/gallery/wedding/wedding06.jpg";
import galleryImg7 from "../../assets/gallery/wedding/wedding07.jpg";
import galleryImg8 from "../../assets/gallery/wedding/wedding08.jpg";
import galleryImg9 from "../../assets/gallery/wedding/wedding09.jpg";
import galleryImg10 from "../../assets/gallery/wedding/wedding10.jpg";
import galleryImg11 from "../../assets/gallery/wedding/wedding11.jpg";
import galleryImg12 from "../../assets/gallery/wedding/wedding12.jpg";
import galleryImg13 from "../../assets/gallery/wedding/wedding13.jpg";
import galleryImg14 from "../../assets/gallery/wedding/wedding14.jpg";
import galleryImg15 from "../../assets/gallery/wedding/wedding15.jpg";
import galleryImg16 from "../../assets/gallery/wedding/wedding16.jpg";
import galleryImg17 from "../../assets/gallery/wedding/wedding17.jpg";
import galleryImg18 from "../../assets/gallery/wedding/wedding18.jpg";
import galleryImg19 from "../../assets/gallery/wedding/wedding19.jpg";

import { NavLink } from "react-router-dom";

export default class Gallery1 extends Component {
  render() {
    var images = [
      {
        src: galleryImg3,
      },
      {
        src: galleryImg4,
      },
      {
        src: galleryImg5,
      },
      {
        src: galleryImg6,
      },
      {
        src: galleryImg7,
      },
      {
        src: galleryImg8,
      },
      {
        src: galleryImg9,
      },
      {
        src: galleryImg10,
      },
      {
        src: galleryImg11,
      },
      {
        src: galleryImg12,
      },
      {
        src: galleryImg13,
      },
      {
        src: galleryImg14,
      },
      {
        src: galleryImg15,
      },
      {
        src: galleryImg16,
      },
      {
        src: galleryImg17,
      },
      {
        src: galleryImg18,
      },
      {
        src: galleryImg19,
      },
    ];
    var settings = {
      columnCount: {
        default: 3,
        mobile: 3,
        tab: 4,
      },
      mode: "dark",
    };
    return (
      <>
        <div
          className="w-full h-[75px] mb-10 bg-repeat bg-contain"
          style={{ backgroundImage: "url(" + pattern + ")" }}
        ></div>
        <div className="container mx-auto px-4">
          <div className="md:p-8 mb-10 pb-10 bg-cream rounded-md shadow-md">
            <h1 className="text-center pt-16 md:p-0 mb-10">Wedding Cookies</h1>
            <Lightbox
              images={images}
              settings={settings}
              className="lb-helper"
            />
            <NavLink
              to="/gallery"
              className="w-fit mx-auto bg-brand hover:bg-brandlt text-cream hover:text-brand border-2 border-brand hover:border-brandlt font-bold py-2 px-4 rounded-full transition-all shadow-md block"
            >
              Back to Galleries
            </NavLink>
          </div>
        </div>

        <PageFooter />
      </>
    );
  }
}
